module.exports = __webpack_public_path__ + "static/media/z1_2_2_thumd.af4ed296.png";